<script setup lang="ts">
import { RouteLocationRaw } from "vue-router";

import { V4HSiteId } from "@/data/common/ids";
import { useTypedIntl } from "@/locales/typed-intl";
import { ERouteName } from "@/router/router.type";

import ConsumptionOverviewSitesDataTable from "@/components/data/table/consumption-overview-sites-data-table.vue";
import BaseLayout from "@/components/layout/base-layout.vue";

const { t, k } = useTypedIntl();

function tableRowRouterLinkPath(siteId: V4HSiteId): RouteLocationRaw {
  return {
    name: ERouteName.SITE_SECTIONS_TREE,
    params: { siteId },
  };
}
</script>

<template>
  <BaseLayout
    :subtitle="t(k.tools.siteManagement.subtitle)"
    :title="t(k.tools.siteManagement.title)"
  >
    <ConsumptionOverviewSitesDataTable
      auto-select-single-site
      :router-link-to="tableRowRouterLinkPath"
      search-input-data-test-id="section-management-search-site-input"
    />
  </BaseLayout>
</template>
